import {AxiosInstance} from 'axios';

export const createHookService = (api: AxiosInstance) => ({
    getHooksByShopAndMonth: (shopUrl: string, monthSelector: string) => 
        api.get(`/admin/hooks/${shopUrl}/${monthSelector}`),
    enableHook: (hookId: string, authKey: string) => 
        api.post(`/admin/hook/${hookId}/enable`, { authKey }),
    disableHook: (hookId: string, authKey: string) => 
        api.post(`/admin/hook/${hookId}/disable`, { authKey }),
    getHookCode: (hookId: string, authKey: string) => 
        api.post(`/admin/hook/${hookId}/code`, { authKey }),
});

export const createAccountService = (api: AxiosInstance) => ({
    getActiveTrials: () => api.get('/admin/active-trials'),
    getExpiredTrials: () => api.get('/admin/expired-trials'),
    getUsageByShopAndMonth: (shopUrl: string, monthSelector: string) => 
        api.get(`/admin/usage/${shopUrl}/${monthSelector}`),
    getAccountByShopUrl: (shopUrl: string) => 
        api.get(`/admin/account/${shopUrl}`),
    getRevenueByShopAndMonth: (shopUrl: string, monthSelector: string) => 
        api.get(`/admin/revenue/${shopUrl}/${monthSelector}`),
    deleteExpiredTrialAccount: (shopUrl: string, authKey: string) =>
        api.post(`/admin/expired-trial-account/${shopUrl}/delete`, { authKey }),
});

export const createUserManagementService = (api: AxiosInstance) => ({
    // This service is kept for backward compatibility but has no methods
});
